export default "__VITE_ASSET__BF2OPiKv__"